/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import TextField from "@material-ui/core/TextField";
import { withTheme } from "@material-ui/core/styles";

import styled from "styled-components";

const StyledTextField = styled(TextField)`

  .MuiFormLabel-root.Mui-focused {
    color: ${(props) =>
      props.error ? undefined : props.theme.palette.primary.main} !important;
    font-weight: 500;
  }

  .MuiFormLabel-root {
    color: ${(props) =>
      props.error ? undefined : props.theme.palette.primary.main} !important;
  }

  .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
    border-color: ${(props) =>
      props.error ? undefined : props.theme.palette.primary.main} !important;
  }

  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${(props) =>
      props.error ? undefined : props.theme.palette.primary.main} !important;
  }

  .MuiFormLabel-root.Mui-error.Mui-focused {
    color: ${(props) => props.theme.palette.error.main} !important;
    font-weight: 500;
  }

  .MuiFormLabel-root.Mui-error {
    color: ${(props) => props.theme.palette.error.main} !important;
  }

  .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline {
    border-color: ${(props) => props.theme.palette.error.main} !important;
  }

  .MuiOutlinedInput-root.Mui-error.Mui-focused
    .MuiOutlinedInput-notchedOutline {
    border-color: ${(props) => props.theme.palette.error.main} !important;
  }
`;

export default withTheme(StyledTextField);
